// extracted by mini-css-extract-plugin
module.exports = {"audioString":"AudioString_audioString__3SSvU"};